<template>
  <div class="page-search">
    <top-bar />
    <div class="container">
      <ym-search :placeholder="placeholder"
                 :popular="popular"
                 :search-value="q"
                 :show-result="showResult"
                 @search="handleSearchInput"
                 @cancel="handleCancel"
      />
      <div v-if="showResult"
           class="search-result-container"
      >
        <div v-if="result"
             class="search-result"
        >
          <ym-tabs v-model="type">
            <ym-tab v-for="item in resultTabs"
                    :key="item.name"
                    :name="item.name"
                    :title="item.title"
            >
              <ym-search-result :q="q"
                                :type="type"
                                :result="result"
              />
            </ym-tab>
          </ym-tabs>
        </div>
        <div v-if="recommend"
             class="search-recommend"
        >
          <ym-block :title="recommend.title"
                    size="medium"
          >
            <ym-product-list :list="recommend.list"
                             type="block"
            />
          </ym-block>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Tabs, Tab } from '@ymba/ym-ui';
  import Search from '@/components/Search';
  import Block from '@/components/Block';
  import List from '@/components/ProductList/List';
  import SearchResult from '@/pages/Search/components/SearchResult';
  import TopBar from '@/components/TopBar';
  import { getPopularSearchKey, getSearchResult } from '@/services/search';

  export default {
    name: 'PageSearch',
    components: {
      'ym-search': Search,
      'ym-block': Block,
      'ym-product-list': List,
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      'ym-search-result': SearchResult,
      TopBar,
    },
    data() {
      return {
        q: '',
        popularProduct: '',
        placeholder: '',
        popular: [],
        showResult: false,
        type: 'all',
        resultTabs: [
          { name: 'all', title: '综合' },
          { name: 'product', title: '课程' },
          { name: 'content', title: '课程内容' },
        ],
        result: null,
        recommend: null,
      };
    },
    watch: {
      type(val) {
        const { q } = this;
        const params = {
          q,
          type: val,
        };
        this.getSearchResult(params);
      },
    },
    methods: {
      init(query) {
        let { product } = query;
        if (product == null) product = '';
        this.getPopularKey(product);
        const { q } = query;
        if (q != null && q !== '') {
          this.handleSearch(q);
        }
      },
      async getPopularKey(product) {
        this.popularProduct = product;
        const data = await getPopularSearchKey(product);
        this.placeholder = data.placeholder;
        this.popular = data.popular;
      },
      async getSearchResult(params) {
        const data = await getSearchResult(params);
        this.result = data.result;
        this.recommend = data.recommend;
        this.showResult = true;
      },
      handleSearchInput(q) {
        const { popularProduct: product } = this;
        const route = { name: 'Search', query: { product, q } };
        this.$router.replace(route);
      },
      handleSearch(q) {
        this.q = q;
        const type = 'all';
        this.type = type;
        const params = {
          q,
          type,
        };
        this.getSearchResult(params);
      },
      handleCancel() {
        const { showResult } = this;
        if (showResult) {
          const { popularProduct: product } = this;
          const route = { name: 'Search', query: { product } };
          this.$router.replace(route);
          this.showResult = false;
          this.q = '';
          return;
        }
        this.$router.go(-1);
      },
    },
    created() {
      const { $route } = this;
      const { query } = $route;
      this.init(query);
    },
    beforeRouteUpdate(to, from, next) {
      const { query } = to;
      this.init(query);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-search {
    min-height: 100%;
    min-height: 100vh;
    background-color: @color-white;
  }

  .container {
    padding: @size-base 0 0;
  }

  .search-result-container {
    margin-top: @size-extra-small;
    background-color: @background-color-base;
  }

  .search-result {
    background-color: @color-white;
  }

  .search-recommend {
    margin-top: @size-small;
  }
</style>
